import React, { Component } from 'react';
// import {Link} from 'react-router-dom'

class ContainerLeft extends Component {
    render() {
        return (
            <div className="col-left animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">
                <div className="flat-title t1">
                    <h4 className="sub-title mb-2">Have a look</h4>
                    <h2 className="title-section color-d12 mg-b34">My projects</h2>
                    <div className="description">
                        <p className="lt-sp01">
                       Some of my front-end and full-stack projects are showcased here
                        </p>
                    </div>
                    <div className="fl-btn btn-general btn-hv-border">
                        <a href="https://github.com/SumanJK" target="_blank" rel="noreferrer" className="f-w500 text-one color-1 lt-sp1 border-corner2">View Github</a>
                    </div>
                </div>
          </div>
        );
    }
}

export default ContainerLeft;
